/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRequestAppointmentModalLoader_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRequestAppointmentModal_user">;
    readonly " $refType": "PdpRequestAppointmentModalLoader_user";
};
export type PdpRequestAppointmentModalLoader_user$data = PdpRequestAppointmentModalLoader_user;
export type PdpRequestAppointmentModalLoader_user$key = {
    readonly " $data"?: PdpRequestAppointmentModalLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRequestAppointmentModalLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRequestAppointmentModalLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModal_user",
      "args": null
    }
  ]
};
(node as any).hash = 'e64700477dc2c58741a7f79a7b8446d9';
export default node;
